var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { ThemeProvider, useTheme } from "../../hooks/useTheme";
import { makeStyles } from "../../styles/index";
var styles = function (theme) { return ({
    root: {
        height: 56,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        position: 'relative',
        display: 'flex',
        flex: '0 0 auto',
        alignItems: 'center',
        // SVG,IconButtonが子の最初にあるときは左のpaddingを8pxにする
        // (ネガティブマージンで対応)
        '& > svg:first-child, & > .SnIconButton-root:first-child': {
            marginLeft: theme.spacing(-2),
        },
        // SVG,IconButtonが子の最後にあるときは右のpaddingを8pxにする
        // (ネガティブマージンで対応)
        '& > svg:last-child, & > .SnIconButton-root:last-child': {
            marginRight: theme.spacing(-2),
        },
    },
    light: {
        color: theme.palette.light.text.primary,
        backgroundColor: theme.palette.light.background.paper,
        '&$primary': {
            color: theme.palette.primary.main,
        },
    },
    dark: {
        color: theme.palette.dark.text.primary,
        backgroundColor: theme.palette.dark.background.paper,
        '&$primary': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    primary: {},
}); };
var useStyles = makeStyles(styles, { name: 'SnAppBar' });
export var AppBar = React.forwardRef(function (props, ref) {
    var _a;
    var dark = props.dark, light = props.light, primary = props.primary, propClassName = props.className, others = __rest(props, ["dark", "light", "primary", "className"]);
    var classes = useStyles(props);
    var theme = useTheme({ dark: dark, light: light });
    var className = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.primary] = primary,
        _a), propClassName);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement("header", __assign({ className: className, ref: ref }, others))));
});
